export enum Language {
  SV = 'sv',
  EN = 'en',
  NB = 'nb',
  FI = 'fi',
  DK = 'dk',
}
